import { prependZero } from 'utils/string';

export const getLocalDate = (string, splitCharacter = '_') => {
  const [
    year, month, day, hour, minute, second,
  ] = string.split(splitCharacter);

  // Messed up format to ISO 8601 format, to get locale timezone, minus 1 hour time difference
  const date = new Date(`${year}-${month ?? '01'}-${day ?? '01'}T${prependZero(Number(hour - 1)) ?? '00'}:${minute ?? '00'}:${second ?? '00'}Z`);
  return date;
};

export default {
  getLocalDate,
};
